import { useState, useRef, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { FaBars, FaTimes } from "react-icons/fa";
import { Link } from "react-router-dom";
import { GetProfile } from "../../api/get";
import { FaCaretDown } from "react-icons/fa";

const Header = (props) => {
  const [hover, setHover] = useState();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const mobileMenuRef = useRef(null);
  const userData = JSON.parse(localStorage.getItem("willguru-token"));

  const handleLogout = () => {
    localStorage.removeItem("willguru-token");
    navigate("/");
  };
  const toggleMobileMenu = () => {
    setIsMobileMenuOpen((prev) => !prev);
  };
  // Close menu when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        mobileMenuRef.current &&
        !mobileMenuRef.current.contains(event.target)
      ) {
        setIsMobileMenuOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div className="h-[90px] bg-primary text-gray-200 flex items-center">
      <div className="container">
        <div className="flex justify-between items-center">
          {/* Logo */}
          <div className="w-[15%] max-lg:w-[150px]">
            <Link to={"https://willsguru.com.au/"}>
              <img
                src="/assets/images/wills-guru-logo-white.png"
                alt="wills-guru-logo-white"
              />
            </Link>
          </div>
          {![
            "/",
            "/signup",
            "/account-recovery",
            "/make-will-online/subscription/couples",
            "/make-will-online/subscription/options",
            "/make-will-online/subscription/payment-couple",
            "/guardian/review",
            "/onboarding"
          ].includes(location.pathname) &&
            !location.pathname.includes("/reset-password") && (
              <div>
                <button
                  aria-label="navigation"
                  onClick={toggleMobileMenu}
                  className="md:hidden text-gray-200 transition duration-300 focus:outline-none hover:text-white"
                >
                  {isMobileMenuOpen ? (
                    <FaTimes className="text-3xl" />
                  ) : (
                    <FaBars className="text-3xl" />
                  )}
                </button>

                <div className="hidden md:flex">
                  <ul className="flex">
                    <li className="text-lg pr-8">
                      <Link
                        to={"/document"}
                        className="transition duration-300 focus:outline-none focus:text-yellow-500 hover:underline hover:text-yellow-500 text-[16px]"
                      >
                        Document
                      </Link>
                    </li>
                    <li className="text-lg pr-8">
                      <Link
                        to={"/offer"}
                        className="transition duration-300 focus:outline-none focus:text-yellow-500 hover:underline hover:text-yellow-500 text-[16px]"
                      >
                        Offers 
                      </Link>
                    </li>
                    <li className="text-lg pr-8">
                      <Link
                        to={"/invite"}
                        className="transition duration-300 focus:outline-none focus:text-yellow-500 hover:underline hover:text-yellow-500 text-[16px]"
                      >
                        Invite
                      </Link>
                    </li>
                    <li
                      onMouseEnter={() => setHover(true)}
                      className="relative flex items-center gap-1 cursor-pointer text-left"
                      id="menu-button"
                      aria-expanded="true"
                      aria-haspopup="true"
                    >
                      {userData
                        ? `${userData.first_name} ${userData.last_name}`
                        : ""}

                      <FaCaretDown />
                      <div
                        onMouseEnter={() => setHover(true)}
                        onMouseLeave={() => setHover(false)}
                        className={
                          hover
                            ? "absolute top-[30px] transition ease-out duration-100 right-0 z-10 mt-2 w-56 origin-top-right rounded-md bg-[#fff] shadow-lg focus:outline-none"
                            : "absolute -top-[300px] transition ease-out duration-100 right-0 z-10 mt-2 w-56 origin-top-right rounded-md bg-[#fff] shadow-lg focus:outline-none"
                        }
                        role="menu"
                        aria-orientation="vertical"
                        aria-labelledby="menu-button"
                        tabIndex="-1"
                      >
                        <div className="py-1" role="none">
                          <a
                            href="/profile"
                            className="block hover:text-black hover:font-semibold px-4 py-2 text-sm text-gray-700"
                            role="menuitem"
                            tabIndex="-1"
                            id="menu-item-0"
                          >
                            My Profile
                          </a>
                          <a
                            href="/order-history"
                            className="block hover:text-black hover:font-semibold px-4 py-2 text-sm text-gray-700"
                            role="menuitem"
                            tabIndex="-1"
                            id="menu-item-1"
                          >
                            Order History
                          </a>
                          <a
                            href="#"
                            className="block hover:text-black hover:font-semibold px-4 py-2 text-sm text-gray-700"
                            role="menuitem"
                            tabIndex="-1"
                            id="menu-item-2"
                          >
                            Help Centre
                          </a>
                          <form action="#" role="none">
                            <button
                              onClick={handleLogout}
                              type="button"
                              className="block hover:text-black hover:font-semibold w-full px-4 py-2 text-left text-sm text-gray-700"
                              role="menuitem"
                              tabIndex="-1"
                              id="menu-item-3"
                            >
                              Sign out
                            </button>
                          </form>
                        </div>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            )}
        </div>
        {/* Mobile Navigation */}
        {isMobileMenuOpen && (
          <div
            ref={mobileMenuRef}
            className="flex flex-col items-center  text-gray-200 pb-8 w-full absolute left-0 top-16 z-10 bg-primary"
          >
            <div className="text-lg my-3">
              <Link
                to={"/document"}
                className="font-bold transition duration-300 focus:outline-none focus:text-yellow-500 hover:underline hover:text-yellow-500"
              >
                Document
              </Link>
            </div>
            <div className="text-lg my-3">
              <Link
                to={"/offer"}
                className="font-bold transition duration-300 focus:outline-none focus:text-yellow-500 hover:underline hover:text-yellow-500"
              >
                Offers
              </Link>
            </div>
            <div className="text-lg my-3">
              <Link
                to={"/invite"}
                className="font-bold transition duration-300 focus:outline-none focus:text-yellow-500 hover:underline hover:text-yellow-500"
              >
                Invite
              </Link>
            </div>
            <div className="text-lg my-3">
              <Link
                to={"/profile"}
                className="font-bold transition duration-300 focus:outline-none focus:text-yellow-500 hover:underline hover:text-yellow-500"
              >
                My Profile
              </Link>
            </div>
            <div className="text-lg my-3">
              <Link
                to={"/order-history"}
                className="font-bold transition duration-300 focus:outline-none focus:text-yellow-500 hover:underline hover:text-yellow-500"
              >
                Order History
              </Link>
            </div>
            <div className="text-lg my-3">
              <Link
                to={"#"}
                className="font-bold transition duration-300 focus:outline-none focus:text-yellow-500 hover:underline hover:text-yellow-500"
              >
                Help Centre
              </Link>
            </div>
            <div className="text-lg my-3">
              <button
                onClick={handleLogout}
                type="button"
                className="font-bold block text-gray-200  transition duration-300 hover:text-yellow-500"
                role="menuitem"
                tabIndex="-1"
                id="menu-item-3"
              >
                Sign out
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default Header;
